import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-print-icon',
  templateUrl: './general-print.component.html'
})
export class GeneralPrintComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
